import axios from 'axios'
import StorageService from '@services/storage.service'
import ApiService from '@services/api.service'
import userService from '@services/business/user.service'

const AuthService = {
  getAccessToken() {
    return AuthService.getToken()
  },

  getToken() {
    var AuthTokens = StorageService.getAuthToken()
    if (AuthTokens === null || AuthTokens === undefined) {
      var TokenUri = `${document.location.protocol}//${document.location.host}/.auth/me`

      if (process.env.NODE_ENV === 'development') {
        var tenent = process.env.VUE_APP_TENENT
        var clientId = process.env.VUE_APP_CLIENT_ID

        var redirectUri = `${document.location.protocol}//${document.location.host}`

        if (window.location.href.indexOf('code') === -1) {
          window.location = `https://login.microsoftonline.com/${tenent}/oauth2/authorize?client_id=${clientId}&response_type=code&redirect_uri=${redirectUri}&response_mode=query`

          return new Promise(function(resolve) {
            resolve({
              access_token: '',
            })
          })
        } else {
          var params = {}
          window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(
            m,
            key,
            value
          ) {
            params[key] = value
          })

          var authCode = params.code

          // The Redirect Uri must be added to AD and currently includes:
          // http://localhost:8080
          TokenUri = `${process.env.VUE_APP_ROOT_API}/auth/token?authCode=${authCode}&appName=TechApp&redirectUri=${redirectUri}`
        }
      }

      return axios.get(TokenUri).then(function(response) {
        AuthService.Save(response.data[0])
        var AuthTokens = JSON.parse(StorageService.getAuthToken())

        AuthService.StartRefreshTimer()

        var data = {
          access_token: AuthTokens.access_token,
        }
        return data
      })
    } else {
      AuthTokens = JSON.parse(AuthTokens)
      if (AuthService.RefreshTimerId === undefined)
        AuthService.StartRefreshTimer()

      return new Promise(function(resolve) {
        var token = AuthTokens.access_token
        resolve({
          access_token: token,
        })
      })
    }
  },

  Save(data) {
    var token = ''
    var expiresOn = ''
    var roles = []
    if (data != null) {
      if (process.env.NODE_ENV === 'production') {
        token = data.id_token
        expiresOn = data.expires_on
      } else {
        token = data.access_token
        expiresOn = new Date(data.expires_on * 1000).toISOString()
      }

      if (data.user_claims != null) {
        for (var i = 0; i < data.user_claims.length; i++) {
          if (data.user_claims[i].typ === 'roles') {
            roles.push(data.user_claims[i].val)
          }
        }
      }
    }

    StorageService.saveAuthToken(
      JSON.stringify({
        access_token: token,
        expires_on: expiresOn,
        roles: roles,
      })
    )
  },

  RefreshToken() {
    if (process.env.NODE_ENV === 'production') {
      var RefreshUri = `${document.location.protocol}//${document.location.host}/.auth/refresh`
      axios
        .get(RefreshUri)
        .then(function(response) {
          AuthService.ClearToken()
          ApiService.setHeader()
        })
        .catch((err) => {
          if (err.response != null && err.response.status === 401) {
            AuthService.Logout()
          }
        })
    } else {
      AuthService.ClearToken()
      ApiService.setHeader()
    }
  },

  StartRefreshTimer() {
    if (AuthService.RefreshTimerId !== undefined)
      clearTimeout(AuthService.RefreshTimerId)

    AuthService.RefreshTimerId = setTimeout(
      AuthService.RefreshToken,
      AuthService.ExpiresIn()
    )
  },

  Login() {
    AuthService.ClearToken()
    userService.clearUserInfo()
    if (process.env.NODE_ENV === 'production') {
      var LoginUri = `${document.location.protocol}//${document.location.host}/.auth/login/aad?post_login_redirect_url=/`
      window.location = LoginUri
    } else {
      ApiService.setHeader()
    }
  },

  Logout() {
    AuthService.ClearToken()
    userService.clearUserInfo()
    if (process.env.NODE_ENV === 'production') {
      var LoginUri = `${document.location.protocol}//${document.location.host}/.auth/logout`
      window.location = LoginUri
    } else {
      ApiService.setHeader()
    }
  },

  ExpiresIn() {
    var AuthTokens = JSON.parse(StorageService.getAuthToken())
    var now = new Date().getTime()
    var expiresOn = Date.parse(AuthTokens.expires_on)
    var expiresIn = Math.max(1000, expiresOn - now)
    return expiresIn
  },

  ClearToken() {
    StorageService.removeAuthToken()
  },

  HasRole(role) {
    var AuthTokens = JSON.parse(StorageService.getAuthToken())

    if (AuthTokens != null && AuthTokens.roles != null) {
      for (var i = 0; i < AuthTokens.roles.length; i++) {
        if (AuthTokens.roles[i] === role) {
          return true
        }
      }
    }

    return false
  },
}

export default AuthService
